import * as React from "react";
import { useGetProviderProgramsQuery } from "../reducers/registerapi";
import { useParams } from "react-router";
import Loading from "../components/loading";
import Program from "./provider/program"

// Eventually will list all available programs that a provider has to offer.
const Provider = () => {
    const { providerid } = useParams();

    const { data, error, isSuccess } = useGetProviderProgramsQuery(
        { id: providerid ?? "?" }
    );

    if (!isSuccess) {
        return (
            <div className="container py-3">
                <Loading />
            </div>
        );
    }

    if (error) {
        return (
            <div className="container py-3">
                <div className="alert alert-danger">
                    Sorry, we cannot find that provider.
                </div>
            </div>
        );
    }

    let programlist: React.JSX.Element;
    let warning: React.JSX.Element | null = null;
    if (data.programs.length > 0) {
        if (!data.hasPaymentProcessor) {
            warning = (<div className="alert alert-danger"><strong>{data.providerName}</strong> currently isn't accepting payments online. Please contact directly to register for their programs.</div>)
        }

        const programs = data.programs.map((program) => <Program key={program.programCode} program={program} />);
        programlist = <div className="programlist">{programs}</div>;
    }
    else {
        programlist = (<div className="alert alert-warning">
            {data.providerName} has no program that you can currently register for online.</div>)
    }

    return (
        <div className="container py-3">
            <h3>{data.providerName} Programs</h3>
            {warning}
            {programlist}
        </div>
    );
};

export default Provider;
